import React from 'react';
import { connect } from 'react-redux';
import FilterWrapper from '../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../components/Common/InputWrapper';
import NowSelect from '../../../../components/Common/NowSelect';
import NowInput from '../../../../components/Common/NowInput';
import FromToDatePicker from '../../../../components/Common/FromToDatePicker';
import {
  EnumOrderGroupStatus,
  EnumOrderListFilter,
} from '../../../../constants/enum';
import { trans } from '../../../../localization/index';
import NowCheckbox from '../../../../components/Common/NowCheckbox';
import { handleChangeFilters } from '../actions';

class OrderManagementFilter extends React.Component {
  restaurantOptions = this.props.restaurants.map(res => ({
    value: res.restaurant_id,
    label: res.name,
  }));

  handleChangeOrderCode = evt => {
    const { handleChangeFiltersConnect } = this.props;
    const { value } = evt.target || {};
    handleChangeFiltersConnect('orderCode', value.trim());
  };

  handleChangeFilter = value => {
    const { filters, handleChangeFiltersConnect, handleSearchOrder } = this.props;
    const { filter } = filters;
    if (value === null || value.value !== filter.value) {
      handleChangeFiltersConnect('filter', value);
      handleSearchOrder();
    }
  };

  handleKeyPress = event => {
    const { handleSearchOrder } = this.props;
    if (event.key === 'Enter') {
      handleSearchOrder();
    }
  };

  render() {
    const {
      filters,
      openSelectCurrentRestaurantModal,
      currentRestaurant,
      handleChangeFiltersConnect,
      handleSearchOrder,
      handleSearchToday,
      toggleAutoReload,
      changeFilterStatus,
    } = this.props;
    const {
      fromDate,
      toDate,
      orderCode,
      status,
      filter,
      isAutoReload,
    } = filters;
    const { restaurant_id: restaurantId = -1, name } = currentRestaurant;
    const restaurant = { value: restaurantId, label: name };

    const orderGroupStatus = Object.keys(EnumOrderGroupStatus).map(key => ({
      value: EnumOrderGroupStatus[key].id,
      label: trans(EnumOrderGroupStatus[key].description),
    }));

    const orderListFilter = Object.keys(EnumOrderListFilter).map(key => ({
      value: EnumOrderListFilter[key].id,
      label: trans(EnumOrderListFilter[key].description),
    }));

    return (
      <FilterWrapper>
        <InputWrapper label={trans('mod_filter_find_order_code')} width={200}>
          <NowInput
            value={orderCode}
            onChange={this.handleChangeOrderCode}
            name="orderCode"
            placeholder={trans('mod_input_order_code')}
            onKeyPress={this.handleKeyPress}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_restaurant_list')} width={300}>
          <NowSelect
            value={restaurant}
            options={this.restaurantOptions}
            isClearable={false}
          />
          <span
            className="frame-current-restaurant"
            onClick={() => openSelectCurrentRestaurantModal(true)}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_filter_status')} width={200}>
          <NowSelect
            value={status}
            options={orderGroupStatus}
            onChange={changeFilterStatus}
            isClearable={false}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_filter_filter')} width={200}>
          <NowSelect
            value={filter}
            options={orderListFilter}
            onChange={this.handleChangeFilter}
            isClearable={false}
            disabled={status.value !== EnumOrderGroupStatus.COMPLETED.id}
          />
        </InputWrapper>
        <InputWrapper label={trans('mod_filter_time')} width={300}>
          <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={date => handleChangeFiltersConnect('fromDate', date)}
            handleChangeToDate={date => handleChangeFiltersConnect('toDate', date)}
          />
        </InputWrapper>
        {status.value === EnumOrderGroupStatus.PROCESSING.id && (
          <InputWrapper width={200}>
            <NowCheckbox
              value={isAutoReload}
              name={trans('auto_reload')}
              onChange={toggleAutoReload}
            />
          </InputWrapper>
        )}
        <InputWrapper>
          <button
            type="button"
            className="btn btn-red mr-2"
            onClick={handleSearchOrder}
          >
            {trans('mod_filter_search')}
          </button>
          <button
            type="button"
            className="btn btn-white"
            onClick={handleSearchToday}
          >
            {trans('mod_filter_today')}
          </button>
        </InputWrapper>
      </FilterWrapper>
    );
  }
}

const mapDispatchToProps = ({
  handleChangeFiltersConnect: handleChangeFilters
});

export default connect(null, mapDispatchToProps)(OrderManagementFilter);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/components/OrderManagementFilter.jsx